import Api from '..';

const WeaponArtiAssetAPI = {
  async getAllCharacterAssets() {
    return Api.get(`/game-assets/weapon-arti/all`);
  }
};

export default WeaponArtiAssetAPI;
